module.exports = __webpack_public_path__ + "3d064bd1e2e909f806dfe3e37d4f91dd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-26.png
// module id = 2947
// module chunks = 0